"use client";

// packages/eden-alert/src/components/Alert.jsx
import { useId } from "react";
import styled from "styled-components";
import { Card } from "@churchofjesuschrist/eden-card";
import { Clear } from "@churchofjesuschrist/eden-icons";
import {
  accentColorInfo,
  boxShadowRaised,
  borderColorTertiary,
  spacing4,
  spacing8,
  spacing16,
  spacing24,
  spacing32,
  backgroundColorLevel5,
  spacing48
} from "@churchofjesuschrist/eden-style-constants";
import { A11y as EdenButton } from "@churchofjesuschrist/eden-buttons";
import { H4 } from "@churchofjesuschrist/eden-headings";
import { Text3 } from "@churchofjesuschrist/eden-text";
import { jsx, jsxs } from "react/jsx-runtime";
var barWidth = spacing8;
var borderRadius = "2px";
var space = spacing8;
var AlertCard = styled(Card)`
  box-shadow: ${boxShadowRaised};
  /* Remove the border and replicate a border below in order to handle colored bar */
  border: none;
  border-radius: ${borderRadius};
  background-color: ${backgroundColorLevel5};
`;
var FlexPositionWrapper = styled.div`
  padding: ${spacing16};
  padding-inline-end: ${spacing48};
  display: flex;
  position: relative;
  &:before {
    position: absolute;
    content: "";
    border: 1px solid ${borderColorTertiary};
    border-radius: ${borderRadius};
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    pointer-events: none;
  }
  &:after {
    position: absolute;
    content: "";
    display: block;
    width: ${barWidth};
    height: 100%;
    top: 0;
    inset-inline-start: 0;
    background: ${({ $borderColor }) => $borderColor};
    border-start-start-radius: ${borderRadius};
    border-end-start-radius: ${borderRadius};
  }
`;
var ContentWrapper = styled.div`
  width: 100%;
  z-index: 1;
  display: flex;
  align-items: flex-start;
  gap: ${space};
`;
var IconWrapper = styled.div`
  display: flex;
`;
var Content = styled(Text3)`
  flex: 1;
`;
var Close = styled.div`
  display: flex;
`;
var Button = styled(EdenButton)`
  max-height: ${spacing24};
  position: absolute;
  top: ${spacing16};
  inset-inline-end: ${spacing16};
  /* Increase the click area without taking more space */
  &:before {
    position: absolute;
    content: "";
    display: block;
    width: ${spacing32};
    height: ${spacing32};
    top: -${spacing4};
    left: -${spacing4};
  }
`;
var Alert = ({
  children,
  onClose,
  Icon,
  title,
  renderTitleAs = "h2",
  color = accentColorInfo,
  closeLabel = "Close",
  ...props
}) => {
  const titleId = useId();
  const labelledBy = title ? titleId : null;
  return /* @__PURE__ */ jsx(AlertCard, { "aria-labelledby": labelledBy, ...props, children: /* @__PURE__ */ jsxs(FlexPositionWrapper, { $borderColor: color, children: [
    /* @__PURE__ */ jsxs(ContentWrapper, { children: [
      /* @__PURE__ */ jsx(IconWrapper, { children: Icon && /* @__PURE__ */ jsx(Icon, { size: spacing24, color }) }),
      /* @__PURE__ */ jsxs(Content, { children: [
        title && /* @__PURE__ */ jsx(H4, { renderAs: renderTitleAs, id: titleId, children: title }),
        children
      ] })
    ] }),
    onClose && /* @__PURE__ */ jsx(Close, { children: /* @__PURE__ */ jsx(Button, { title: closeLabel, size: "small", onClick: onClose, children: /* @__PURE__ */ jsx(Clear, { size: spacing24 }) }) })
  ] }) });
};
Alert.displayName = "Alert";
var Alert_default = Alert;
export {
  Alert_default as default
};
